const IP_URL = process.env.REACT_APP_NODE_API_URL

export const checkAuthLogin = async (token_jwt) => {
    try {
        //sconsole.log('Se va a solicitar authLogin')
        const response = await fetch(IP_URL + "api_login/checkAuthLogin", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({token_jwt}),
      });
      const data = await response.json();
      return data;
    } catch (error) {
      //console.error("Error al iniciar sesión", error);
      var aux = 0;
    } 
  };